import "core-js/modules/es.object.assign.js";

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

import * as React from 'react';
import Svg, { Path } from 'react-native-svg';

function Service(props) {
  return React.createElement(Svg, _extends({
    width: "1em",
    height: "1em",
    viewBox: "0 0 24 24"
  }, props), React.createElement(Path, {
    fillRule: "evenodd",
    d: "M9 4a1 1 0 011-1h4a1 1 0 110 2h-4a1 1 0 01-1-1zM1 21a1 1 0 011-1h20a1 1 0 110 2H2a1 1 0 01-1-1zm18.012-9.65c1.13 1.507 1.72 3.259 1.914 4.65H3.074c.195-1.391.783-3.143 1.913-4.65C6.38 9.494 8.595 8 12 8c3.406 0 5.62 1.494 7.012 3.35zM12 6c-4.094 0-6.88 1.84-8.613 4.15C1.687 12.418 1 15.132 1 17a1 1 0 001 1h20a1 1 0 001-1c0-1.868-.686-4.582-2.387-6.85C18.879 7.84 16.093 6 12 6z",
    clipRule: "evenodd"
  }));
}

export default Service;